import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'

try {
  createRoot(document.getElementById('root')).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
} catch (error) {
  console.error("Failed to mount React app:", error);
  document.body.innerHTML = `<div style="color: red; padding: 20px;"><h1>Application Error</h1><pre>${error.message}\n${error.stack}</pre></div>`;
}
